import { Variant } from '~/@types/product'
import { akairosApi, PRODUCT_TYPES } from '~/lib/constants'

import { CustomizerVariant } from '~/providers/ProductPageProvider'

export async function getBackgroundUrl(
  productVariant: Variant,
  customizerVariant: CustomizerVariant,
  productType,
  isEngraving,
) {
  if (!productVariant?.sku) return null

  let sku = productVariant.sku.split('-').join('/')

  let suffix = ''
  if (!customizerVariant?.sku) {
    if (productType === PRODUCT_TYPES.CANDLEV2) {
      suffix = sku.split('/').slice(-1)?.[0]
    }
  } else {
    const mainProductVariantSku = customizerVariant?.sku ?? ''
    suffix = mainProductVariantSku.slice(
      mainProductVariantSku.lastIndexOf('-') + 1,
      mainProductVariantSku.length,
    )
  }

  if (!suffix) return null

  if (isEngraving && customizerVariant?.sku.endsWith('14')) {
    suffix += '_1'
  }

  if (
    productType === PRODUCT_TYPES.CANDLE ||
    productType === PRODUCT_TYPES.POMANDER ||
    productType === PRODUCT_TYPES.CANDLEV2 ||
    productType === PRODUCT_TYPES.INFUSION
  ) {
    sku = sku.split('/').slice(0, -1).join('/')
  }

  let url = `https://${akairosApi.MAIN}/storage/assets/img/products/${sku}/${suffix}.jpg`

  if (productType === PRODUCT_TYPES.HERBARIUM) {
    url = `https://${akairosApi.MAIN}/v1/label/preview/${productVariant?.sku}-${suffix}`
  }

  try {
    const response = await fetch(url)
    if (response?.status !== 200) {
      throw new Error()
    } else {
      return { url, isFallBack: false }
    }
  } catch {
    return { url: customizerVariant?.variantImage?.src, isFallBack: true }
  }
}
